/**
 * Injuries Service - Re-exports from generated service
 *
 * This file wraps the auto-generated injuries service to provide:
 * - Stable import path that won't be overwritten by codegen
 * - All generated hooks and types
 * - Manual types/hooks for endpoints excluded from OpenAPI schema
 */

import { baseApiClient as api } from './baseService';
import { enhancedApi as generatedApi } from './generated/injuriesService';

// Re-export all types from generated service
export type {
  BodyPart,
  CreateInjury,
  EntitySuggestionStatus,
  InjuryAcceptApiArg,
  InjuryCreateApiArg,
  InjuryDestroyApiArg,
  InjuryListApiArg,
  InjuryUpdateApiArg,
  ReadInjury,
  UpdateInjury,
} from './generated/injuriesService';

// =============================================================================
// Manual type definitions for endpoints excluded from OpenAPI schema
// (drf-spectacular can't resolve ReadInjuryWithSuggestion Pydantic model)
// =============================================================================

export type SuggestionStatus =
  | 'pending'
  | 'applied'
  | 'partially_applied'
  | 'rejected';

export type SuggestionProvenanceStatus = 'consistent' | 'compromised';

export type SuggestionAction = 'add_new' | 'patch_existing' | 'delete';

export type ReadSuggestionSummary = {
  id: string;
  created_at: string;
  modified_at: string;
  status: SuggestionStatus;
  provenance_status: SuggestionProvenanceStatus;
  action: SuggestionAction;
  target_id?: string | null;
  extraction_count: number;
};

export type ReadInjuryWithSuggestion = {
  body_part: import('./generated/injuriesService').BodyPart;
  description?: string | null;
  id: string;
  person_id: string;
  approval_status?: import('./generated/injuriesService').EntitySuggestionStatus;
  created_at: string;
  modified_at: string;
  pending_suggestion?: ReadSuggestionSummary | null;
};

export type InjuryListWithSuggestionsApiArg = {
  personId: string;
};

export type InjuryWithSuggestionApiArg = {
  personId: string;
  id: string;
};

// =============================================================================
// Inject manual endpoints for with-suggestions queries
// =============================================================================

const injectedApi = api
  .enhanceEndpoints({
    addTagTypes: ['persons'] as const,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      injuryListWithSuggestions: build.query<
        ReadInjuryWithSuggestion[],
        InjuryListWithSuggestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/persons/${queryArg.personId}/injuries/with-suggestions/`,
        }),
        providesTags: ['persons'],
      }),
      injuryWithSuggestion: build.query<
        ReadInjuryWithSuggestion,
        InjuryWithSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/persons/${queryArg.personId}/injuries/${queryArg.id}/with-suggestion/`,
        }),
        providesTags: ['persons'],
      }),
    }),
    overrideExisting: false,
  });

// Export the API for store configuration
export const injuriesApi = generatedApi;

// Export hooks from the generated API
export const {
  useInjuryListQuery,
  useInjuryCreateMutation,
  useInjuryRetrieveQuery,
  useInjuryUpdateMutation,
  useInjuryDestroyMutation,
  useInjuryAcceptMutation,
} = generatedApi;

// Export manual hooks
export const {
  useInjuryListWithSuggestionsQuery,
  useInjuryWithSuggestionQuery,
} = injectedApi;
